// extracted by mini-css-extract-plugin
module.exports = {"container":"PortfolioCard_container__1kh7T","avatar":"PortfolioCard_avatar__GFA1v","name":"PortfolioCard_name__2Cxx2","sending":"PortfolioCard_sending__JEhdn"};